import * as selectors from './email-sequence-template-group-selectors';

export const EmailSequenceTemplateGroups = {
    ...selectors,
} as const;
